import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormLabel = ({ id, label, required }) => {
  if (!label) return <></>;

  return (
    <label htmlFor={id} id={`${id}Label`} className="form-label">
      {required && '*'}
      {' '}
      <FormattedMessage {...label} />
    </label>
  );
};

export default FormLabel;
